import { gql } from '@apollo/client';

export default gql`
  query bookingSearch(
    $departureDate: String!
    $travelEndDate: String
    $endDate: String
    $passengerName: String
    $passengerEmail: String
    $serviceName: String
  ) {
    bookingSearch(
      departureDate: $departureDate
      travelEndDate: $travelEndDate
      endDate: $endDate
      passengerName: $passengerName
      passengerEmail: $passengerEmail
      serviceName: $serviceName
    ) {
      reference
      status
      expiryTimestamp
      customer {
        firstName
        lastName
      }
      products {
        code
        type
        name
      }
      passengerCount
      outboundRoute {
        dateTime
        origin
        destination
      }
      inboundRoute {
        dateTime
        origin
        destination
      }
      externalBookingReferences {
        source
        type
        externalId
      }
    }
  }
`;
